import React from "react";
import { withTranslation } from 'react-i18next'

class CardForm extends React.Component {

    renderField = ({
        input,
        title,
        type,
        placeholder,
        required,
        className,
        style,
        meta: { touched, error }
    }) => (
        <>
            <input {...input} title={title} placeholder={placeholder} style={style} required={required} type={type} autoComplete="off" spellCheck={false} className={`${className} ${(touched && error) ? 'is-invalid' : ''}`} />
            {touched && error && <div className="invalid-feedback">{this.props.t(error)}</div>}
        </>
    );

    render() {
        const { t } = this.props;
        return (
            <>
                <div className="contact-form-area">

                    <h4 className="title  d-flex justify-content-center align-items-center">
                        <i className="icon fa-solid fa-credit-card px-1 text-primary"></i>
                        {t("Pages.Register.steps.CardForm")}
                    </h4>
                    <div className="contact-form" >
                        <div className="form-group w-100 text-center d-flex justify-content-around align-items-center">
                            <button type="button" className={`custom-button secondary-button w-100`}  >
                                <span className="d-flex justify-content-center align-items-center">
                                    تَأكِيد الطَّلب
                                </span>
                            </button>
                        </div>
                    </div>

                    <div className={`contact-form p-3 w-100 mt-4 inner-box p-3 pt-4 `} style={{
                        background: 'rgb(170 233 255)',
                        border: '1px solid rgb(0 191 255)',
                        borderRadius: '10px'
                    }}  >
                        <h4 className="mb-4">
                            مُقَابِل شِرَاء " اِشتِراك مَدْرَسة " ستحْصل على :
                        </h4>
                        <div>
                            <ul>
                                <li>
                                    <i className="fa-solid fa-circle-small ml-2 fa-2xs mb-0"></i>
                                    فَتْح جميع مُحْتويات اَلموْقِع لِمدَّة سنة ( أَلعَاب , مِلفَّات مُحَوسبَة , مِلفَّات وَرَقيَّة ).
                                </li>
                                <li>
                                    <i className="fa-solid fa-circle-small ml-2 fa-2xs mb-0"></i>
                                    فَتْح حِسَاب مُنْفَرِد لِكلِّ مُعلِّم وَلجمِيع الطُّلَّاب.
                                </li>
                                <li>
                                    <i className="fa-solid fa-circle-small ml-2 fa-2xs mb-0"></i>
                                    إِمْكانيَّة بعث مَهَام مُحَوسبَة لِلطُّلَّاب ( غَيْر مُتَوفرَة بِالاشْتراكات الفرْديَّة ) .
                                </li>
                                <li>
                                    <i className="fa-solid fa-circle-small ml-2 fa-2xs mb-0"></i>
                                    صِفْر مَخاطِر : إِذَا لَم تَكُن راضٍ لِأيِّ سبب ، يُمْكِنك اِسْترْجاع كَامِل المبْلغ خِلَال 30 يوْمًا مِن الاشْتراك .
                                </li>
                                <li>
                                    <i className="fa-solid fa-circle-small ml-2 fa-2xs mb-0"></i>
                                    650 $ ( اِشتِراك سَنوِي )
                                    .
                                </li>
                                <li>
                                    <i className="fa-solid fa-circle-small ml-2 fa-2xs mb-0"></i>
                                    التَّسْجيل سَهْل وسريع ( يُمْكِنك الانْتهاء مِن التَّسْجيل خِلَال 3 دَقائِق )
                                    .
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation('common')(CardForm);